import Component from "../../../../lib/component";

export const ButtonsFieldsetConfig = {
    baseHtmlClass: 'inquiry_form__buttons',
    selector: '.inquiry_form__buttons',
};

export class ButtonsFieldset extends Component {

    static new(inquiryForm) {
        if (!inquiryForm.element) { return null }
        const element = inquiryForm.element.querySelector(ButtonsFieldsetConfig.selector);
        if (element) { return new ButtonsFieldset(element, inquiryForm) };
    }

    constructor(id_or_element, inquiryForm) {
        super({
            element: id_or_element,
            config: ButtonsFieldsetConfig
        });

        this.inquiryForm = inquiryForm;
        this.window = this.inquiryForm.window;
    }

}
